import {RestRequestGET, RestRequestPOST} from "libs/RestRequest";
import Endpoints from "constants/Endpoints";
import reduxStore from "redux/store";
import {clearResource, setResource, setSaveStatusError} from "redux/actions";

const DEMAND_ACTIVE_APPROVAL_RESOURCE_ID = 'demandActiveApproval';
const DEMAND_APPROVAL_HISTORY_LIST_RESOURCE_ID = 'demandApprovalHistoryList';
const DEMAND_APPROVAL_HISTORY_RESOURCE_ID = 'demandApprovalHistory';

const getActiveApproval = async (demandId) => {
    const res = await RestRequestGET(Endpoints.DEMAND_APPROVAL(demandId))
    reduxStore.dispatch(
        setResource(DEMAND_ACTIVE_APPROVAL_RESOURCE_ID, res)
    );
}

const startApproval = async (demandId) => {
    const res = await RestRequestPOST(Endpoints.DEMAND_APPROVAL(demandId))
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false;
    }
}

const selectApprovers = async (demandId, payload) => {
    const res = await RestRequestPOST(Endpoints.DEMAND_APPROVAL_SELECT_APPROVERS(demandId), payload);
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false
    }
}

const sendDecision = async (demandId, payload) => {
    const res = await RestRequestPOST(Endpoints.DEMAND_APPROVAL_SEND_DECISION(demandId), payload);
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false
    }
}

const resetApproval = async (demandId) => {
    const res = await RestRequestPOST(Endpoints.DEMAND_APPROVAL_RESET(demandId));;
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false
    }
}

const stopApproval = async (demandId) => {
    const res = await RestRequestPOST(Endpoints.DEMAND_APPROVAL_STOP(demandId));;
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false
    }
}

const getApprovalHistoryList = async (demandId) => {
    const res = await RestRequestGET(Endpoints.DEMAND_APPROVAL_HISTORY_LIST(demandId))
    reduxStore.dispatch(
        setResource(DEMAND_APPROVAL_HISTORY_LIST_RESOURCE_ID, res.result)
    );
}

const getApprovalHistory = async (demandId, approvalId) => {
    const res = await RestRequestGET(Endpoints.DEMAND_APPROVAL_HISTORY(demandId, approvalId));
    const {resources} = reduxStore.getState();
    if (!!resources[DEMAND_APPROVAL_HISTORY_RESOURCE_ID]) {
        const approvalHistory = resources[DEMAND_APPROVAL_HISTORY_RESOURCE_ID];
        approvalHistory[`${approvalId}`] = res.result;
        // const newApprovalHistory = {};
        // Object.keys(approvalHistory).forEach(k => {
        //     if (k === `${approvalId}`)
        //         newApprovalHistory[k] = res.result;
        //     else
        //         newApprovalHistory[k] = approvalHistory[k];
        // })
        reduxStore.dispatch(
            setResource(DEMAND_APPROVAL_HISTORY_RESOURCE_ID, approvalHistory)
        );
    } else {
        const o = {};
        o[`${approvalId}`] = res.result;
        reduxStore.dispatch(
            setResource(DEMAND_APPROVAL_HISTORY_RESOURCE_ID, o)
        );
    }
}

const getAvailableApprovers = async (demandId, approvalId, stageId) => {
    const res = await RestRequestGET(Endpoints.DEMAND_APPROVAL_HISTORY_GET_APPROVERS(demandId, approvalId, stageId));
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return null;
    }
}

const addApprovers = async (demandId, approvalId, stageId, approverIds) => {
    const res = await RestRequestPOST(Endpoints.DEMAND_APPROVAL_HISTORY_ADD_APPROVERS(demandId, approvalId, stageId), {approvers: approverIds});
    if (res.success) {
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false;
    }
}

const deleteApprover = async (demandId, approval, stage, approver) => {
    const res = await RestRequestPOST(Endpoints.DEMAND_APPROVAL_HISTORY_DELETE_APPROVER(demandId, approval.identity, stage.identity), {approvers: [approver.identity]});
    if (res.success) {
        approval.stages = approval.stages.map(s => {
            if (s.identity === stage.identity) {
                return {
                    ...s,
                    approvers: s.approvers.filter(a => a.identity !== approver.identity)
                }
            } else {
                return s;
            }
        });
        const {resources} = reduxStore.getState();
        const approvalHistory = resources[DEMAND_APPROVAL_HISTORY_RESOURCE_ID];
        approvalHistory[`${approval.identity}`] = approval;
        reduxStore.dispatch(
            setResource(DEMAND_APPROVAL_HISTORY_RESOURCE_ID, approvalHistory)
        );
        return res.result;
    } else {
        reduxStore.dispatch(setSaveStatusError(res.errors[0]));
        return false;
    }
}

const validate = async (demandId) => {
    return RestRequestGET(Endpoints.DEMAND_APPROVAL_VALIDATE(demandId));
}

const clearResources = (resId) => reduxStore.dispatch(clearResource(resId));

export default {
    getActiveApproval,
    startApproval,
    selectApprovers,
    sendDecision,
    resetApproval,
    stopApproval,
    getApprovalHistoryList,
    getApprovalHistory,
    getAvailableApprovers,
    addApprovers,
    deleteApprover,
    validate,
    clearResources,
    DEMAND_ACTIVE_APPROVAL_RESOURCE_ID,
    DEMAND_APPROVAL_HISTORY_LIST_RESOURCE_ID,
    DEMAND_APPROVAL_HISTORY_RESOURCE_ID
}